import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import store from "./app/redux/store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as Actions from "./app/redux/actions";
import i18n from "./config/i18n";

import Layout from "./app/components/layout";
import APP from "./app/routes/intro";
import Marcas from "./app/routes/marcas";
import Catalogo from "./app/routes/catalogo";
import Categorias from "./app/routes/categorias";
import Products from "./app/routes/products/products";
import ProductsType from "./app/routes/products/productsType";
import ProductInfo from "./app/routes/products/productInfo";
import NewCatalog from "./app/routes/custom-catalog/create-catalog";
import CustomProducts from "./app/routes/custom-catalog/custom-products";

import Mail from "./mail";

const Catalog = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    Promise.all([
      store.dispatch(Actions.getCatalogos()),
      store.dispatch(Actions.getCategories()),
      store.dispatch(Actions.getMarcas()),
      store.dispatch(Actions.getPopups()),
    ]).then(() => setReady(true));
  }, []);



  return (
    <Provider store={store}>
        <Layout>
          {ready && (
            
            <Routes>
              <Route path="/" element={<APP />} />

              <Route path="/catalogos" element={<Catalogo />} />

              <Route path="/mail" element={<Mail />} />

              <Route path="/catalogos/new" element={<NewCatalog />} />
              <Route path="/catalogos/new/:name/:type/:childrens" element={<CustomProducts />} />

              <Route path="/catalogos/:catalogoId/add" element={<Categorias />} />


              <Route path="/catalogos/:catalogoId" element={<Categorias />} />
              <Route path="/catalogos/:catalogoId/:categoriaId" element={<Marcas />} />
              <Route path="/catalogos/:catalogoId/:categoriaId/:marcaId" element={<Products />} />
              <Route path="/catalogos/:catalogoId/:categoriaId/:marcaId/:ean" element={<ProductsType />} />
              <Route path="/catalogos/:catalogoId/:categoriaId/:marcaId/:codeEAN/:codeITF" element={<ProductInfo />} />

              <Route path="/categorias" element={<Categorias />} />
              <Route path="/categorias/:categoriaId" element={<Marcas />} />
              <Route path="/categorias/:categoriaId/:marcaId" element={<Products />} />
              <Route path="/categorias/:categoriaId/:marcaId/:ean" element={<ProductsType />} />
              <Route path="/categorias/:categoriaId/:marcaId/:codeEAN/:codeITF" element={<ProductInfo />} />

              <Route path="/marcas" element={<Marcas />} />
              <Route path="/marcas/:marcaId" element={<Products />} />
              <Route path="/marcas/:marcaId/:ean" element={<ProductsType />} />
              <Route path="/marcas/:marcaId/:codeEAN/:codeITF" element={<ProductInfo />} />

              <Route path="/search" element={<Products />} />
              <Route path="/search/:ean" element={<ProductsType />} />
              <Route path="/search/:codeEAN/:codeITF" element={<ProductInfo />} />
            </Routes>
          )}
        </Layout>
    </Provider>
  );
};

export default Catalog;
